import {
  fetchData,
  fileExceedSizeInMo,
  getImageUrl,
  IframelyMedia,
  isImageFile,
  mediaFromIframely,
  uploadFileToUrl,
} from '@prismamedia/one-components';
import {
  useFocusPointGetter,
  useResolvedImageGetter,
  useUploadUrlGetter,
} from 'apollo/queries/uploadImage.image.graphql';

export const useUploadImage = () => {
  const getUploadUrl = useUploadUrlGetter();
  const getResolvedImage = useResolvedImageGetter();
  const getFocusPoint = useFocusPointGetter();

  return async (file: File, namespace: string) => {
    try {
      if (fileExceedSizeInMo(file, 10)) {
        throw new Error('Le fichier fait plus de 10 Mo');
      }

      if (!isImageFile(file)) {
        throw new Error("Le fichier n'est pas une image");
      }

      const {
        getUploadUrl: { key, uploadURL },
      } = await getUploadUrl({
        namespace,
        originalName: file.name,
      });

      await uploadFileToUrl(file, uploadURL);

      const {
        getResolvedImage: { url },
      } = await getResolvedImage({
        key,
      });

      const iframely = await fetchData<IframelyMedia>(
        `${config.IFRAMELY_API_BASEPATH}/iframely?uri=${encodeURIComponent(
          url,
        )}`,
      );

      let oneMedia = mediaFromIframely(iframely);
      const imageUrl = getImageUrl(oneMedia);
      const imageHeight = oneMedia.iframely.meta.height;
      const imageWidth = oneMedia.iframely.meta.width;

      try {
        const res = await getFocusPoint({
          imageUrl,
          imageHeight,
          imageWidth,
        });
        const { x, y, relativeX, relativeY } = res.getFocusPoint;
        oneMedia = { ...oneMedia, focusPoint: { x, y, relativeX, relativeY } };
      } catch (e) {}

      return oneMedia;
    } catch (error) {
      throw new Error(
        `Erreur lors de l'importation du média "${file.name}": ${
          (error as Error)?.message
        }`,
      );
    }
  };
};
